import { ws } from "../../../utils/common";

export const getVolunteersAssociationWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user-association/volunteer/",
    { id_association },
    null,
    true
  );

  if (res.error) {
    throw res;
  } else {
    return res.data;
  }
};

export const getListRequestSubscriptionWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "waiting-volunteer/",
    { id_association },
    null,
    true
  );

  if (res.error) {
    throw res;
  } else {
    return res.data;
  }
};

export const acceptSubscriptionWS = async ({ id, reject }) => {
  const res = await ws(
    "PUT",
    process.env.REACT_APP_ENDPOINT + "waiting-volunteer/" + id,
    null,
    { reject },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const removeVolunteerWS = async ({
  id_association,
  id_user_association,
}) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "user-association/" + id_association,
    null,
    { id_user_association },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const changePermissionAdminWS = async ({
  id_user_association,
  admin,
  id_association,
}) => {
  const res = await ws(
    "PATCH",
    process.env.REACT_APP_ENDPOINT + "user-association/admin/" + id_association,
    null,
    { id_user_association, admin },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const changePermissionMemberWS = async ({
  id_user_association,
  member,
  id_association,
}) => {
  const res = await ws(
    "PATCH",
    process.env.REACT_APP_ENDPOINT +
      "user-association/member/" +
      id_association,
    null,
    { id_user_association, member },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
